angular.module('angus.directives').directive('ngAngusEmailValidation', [
    function () {
        const emailRegex = /^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/;

        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ngModelCtrl) {
                scope.$watch(() => ngModelCtrl.$viewValue, function (val) {
                    const isValid = emailRegex.test(val || '');
                    if (ngModelCtrl.$dirty && val && !isValid) {
                        elem.css('border-color', '#b03535');
                        elem.css('box-shadow', '0 0 5px #d45252');
                    } else if (ngModelCtrl.$dirty && isValid) {
                        elem.css('border-color', '#28921f');
                        elem.css('box-shadow', '0 0 5px #5cd053');
                    } else {
                        elem.css('border-color', '');
                        elem.css('box-shadow', '');
                    }
                });
            }
        };
    }
]);
